import { memo, useCallback } from 'react'
import { createPortal } from 'react-dom'
import { AnimatePresence } from 'framer-motion'
import { useEventListener } from 'hooks'

import * as Styled from './styled'
import type { TProps } from './types'
import { CONTAINER_ANIMATION_PROPS, CONTENT_ANIMATION_PROPS } from './consts'

const NO_ANIMATION = { duration: 0 }

const Popup = ({
  isOpen,
  children,
  onClose,
  disableAnimation,
  ...rest
}: TProps) => {
  const handleEscKey = useCallback(
    (event: KeyboardEvent) => {
      if (isOpen && onClose && event.key === 'Escape') {
        onClose()
      }
    },
    [isOpen, onClose]
  )

  useEventListener('keydown', handleEscKey, document)

  return createPortal(
    <AnimatePresence>
      {isOpen ? (
        <Styled.PopupContainer
          {...CONTAINER_ANIMATION_PROPS}
          {...(disableAnimation && { transition: NO_ANIMATION })}
          {...rest}
        >
          <Styled.BackdropOverlay onClick={onClose} />
          <Styled.PopupContent
            {...CONTENT_ANIMATION_PROPS}
            {...(disableAnimation && {
              transition: NO_ANIMATION,
              exit: {
                ...CONTENT_ANIMATION_PROPS.exit,
                transition: NO_ANIMATION
              }
            })}
            className="popup-content"
          >
            {onClose && <Styled.CloseIcon onClick={onClose} />}
            {children}
          </Styled.PopupContent>
        </Styled.PopupContainer>
      ) : null}
    </AnimatePresence>,
    document.body
  )
}

export default memo(Popup)
